
import { useEffect } from 'react';

const siteUrl = 'https://www.adanailkyardim.com.tr';

const pages = [
  { url: '/', title: 'Ana Sayfa', priority: '1.0', changefreq: 'weekly' },
  { url: '/egitimler', title: 'Eğitimler', priority: '0.9', changefreq: 'weekly' },
  { url: '/blog', title: 'Blog', priority: '0.8', changefreq: 'daily' },
  { url: '/iletisim', title: 'İletişim', priority: '0.7', changefreq: 'monthly' },
];

const lastMod = new Date().toISOString().split('T')[0];

export default function Sitemap() {
  useEffect(() => {
    document.title = 'Site Haritası | Adana İlkyardım Eğitim Merkezi';
  }, []);

  const generateXmlContent = () => {
    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
    xml += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';
    
    pages.forEach(page => {
      xml += '  <url>\n';
      xml += `    <loc>${siteUrl}${page.url}</loc>\n`;
      xml += `    <lastmod>${lastMod}</lastmod>\n`;
      xml += `    <changefreq>${page.changefreq}</changefreq>\n`;
      xml += `    <priority>${page.priority}</priority>\n`;
      xml += '  </url>\n';
    });
    
    xml += '</urlset>';
    return xml;
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generateXmlContent());
    alert('Sitemap XML kopyalandı!');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <h1 className="text-2xl font-semibold text-gray-800" style={{ fontFamily: 'Oswald, sans-serif' }}>
            <a href="/" className="hover:text-teal-600 transition-colors">Site Haritası</a>
          </h1>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 py-12">
        {/* Site Pages */}
        <section className="mb-12">
          <h2 className="text-xl font-semibold text-gray-800 mb-6" style={{ fontFamily: 'Oswald, sans-serif' }}>
            Sayfa Listesi
          </h2>
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="text-left px-6 py-4 text-sm font-medium text-gray-600">Sayfa</th>
                  <th className="text-left px-6 py-4 text-sm font-medium text-gray-600">URL</th>
                  <th className="text-left px-6 py-4 text-sm font-medium text-gray-600">Öncelik</th>
                  <th className="text-left px-6 py-4 text-sm font-medium text-gray-600">Güncelleme</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {pages.map((page, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <a href={page.url} className="text-teal-600 hover:text-teal-700 font-medium">
                        {page.title}
                      </a>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {siteUrl}{page.url}
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
                        {page.priority}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 capitalize">
                      {page.changefreq}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* XML Preview */}
        <section className="mb-12">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-gray-800" style={{ fontFamily: 'Oswald, sans-serif' }}>
              Sitemap XML
            </h2>
            <button
              onClick={copyToClipboard}
              className="inline-flex items-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-copy-line w-5 h-5 flex items-center justify-center"></i>
              XML Kopyala
            </button>
          </div>
          <div className="bg-gray-900 rounded-lg p-6 overflow-x-auto">
            <pre className="text-sm text-green-400 font-mono whitespace-pre-wrap">
              {generateXmlContent()}
            </pre>
          </div>
        </section>

        {/* Instructions */}
        <section className="bg-amber-50 border border-amber-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-amber-800 mb-4 flex items-center gap-2">
            <i className="ri-information-line w-5 h-5 flex items-center justify-center"></i>
            Google Search Console Talimatları
          </h3>
          <ol className="space-y-3 text-amber-900">
            <li className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-amber-200 rounded-full flex items-center justify-center text-sm font-medium">1</span>
              <span><a href="https://search.google.com/search-console" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline">Google Search Console</a>'a gidin ve sitenizi ekleyin</span>
            </li>
            <li className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-amber-200 rounded-full flex items-center justify-center text-sm font-medium">2</span>
              <span>Sol menüden "Site Haritaları" seçeneğine tıklayın</span>
            </li>
            <li className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-amber-200 rounded-full flex items-center justify-center text-sm font-medium">3</span>
              <span>Yukarıdaki XML içeriğini kopyalayın ve <strong>sitemap.xml</strong> dosyası olarak kaydedin</span>
            </li>
            <li className="flex gap-3">
              <span className="flex-shrink-0 w-6 h-6 bg-amber-200 rounded-full flex items-center justify-center text-sm font-medium">4</span>
              <span>Alternatif olarak, her sayfayı "URL Denetimi" ile manuel olarak ekleyebilirsiniz</span>
            </li>
          </ol>
        </section>

        {/* Back Link */}
        <div className="mt-8 text-center">
          <a href="/" className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
            Ana Sayfaya Dön
          </a>
        </div>
      </main>

      {/* Fixed Contact Icons */}
      <aside className="fixed bottom-6 left-6 z-[150] flex flex-col gap-3" aria-label="İletişim butonları">
        <a 
          href="https://wa.me/905324196401" 
          target="_blank" 
          rel="noopener noreferrer nofollow"
          className="w-12 h-12 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="WhatsApp ile iletişime geçin"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
        <a 
          href="mailto:info@assaakademi.com.tr" 
          className="w-12 h-12 flex items-center justify-center bg-[#ecad29] text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="E-posta gönderin"
          aria-label="E-posta"
        >
          <i className="ri-mail-line text-xl"></i>
        </a>
        <a 
          href="tel:08503462772" 
          className="w-12 h-12 flex items-center justify-center bg-white text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer shadow-md"
          title="Bizi arayın: 0850 346 2772"
          aria-label="Telefon"
        >
          <i className="ri-phone-line text-xl"></i>
        </a>
      </aside>
    </div>
  );
}
